import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Divider } from '@mui/material';
import { useAuth } from './AuthProvider';
import { get_auth } from './auth';
import LogoutIcon from "@mui/icons-material/Logout";
import { serverUrl, configKeys, useConfig } from './ConfigHolder';
import { LangSelection } from './LangSelection';
import LockIcon from '@mui/icons-material/Lock';
import SubmitNewPassword from './SubmitNewPassword';
import { isEmpty } from 'lodash';
import JustPayment from './JustPayment';
import { formatDate} from './generalUtils';
import ErrorDispatcher from './ErrorDispatcher';
import { ButtonSecurePayment } from './ButtonSecurePayment';


const Profile = ({ onClose, onStartPayment }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [accountStatus, setAccountStatus] = useState({});
  const [showSubmitNewPassword, setShowSubmitNewPassword] = useState(false);
  const [error, setError] = useState(null);
  const { logout } = useAuth();
  const { config } = useConfig();

  useEffect(() => {
    const getUser = async () => {
      try {
        const uri = `${serverUrl}/email-name`;
        const res = await get_auth(uri, {}, 'json', logout);
        console.log(res);
        setName(res.data.name);
        setEmail(res.data.email);
      } catch (err) {
        setError(err);
      }
    };

    const getAccountStatus = async () => {
      try {
        const uri = `${serverUrl}/account-status`;
        const res = await get_auth(uri, {}, 'json', logout);
        console.log('Account status:', res);
        setAccountStatus(res.data.account_status);
      } catch (err) {
        setError(err);
      }
    };

    getUser();
    getAccountStatus();
  // eslint-disable-next-line
  }, []);

  const handleLogout = () => {
    logout();
    if (onClose) {
      onClose();
    }
  };

  const handleChangePasswordClick = () => {
    setShowSubmitNewPassword(!showSubmitNewPassword);
  };

  const isExpirationNear = (expirationDate) => {
    const now = new Date();
    const expiration = new Date(expirationDate);
    // const diffTime = Math.abs(expiration - now);
    const diffTime = expiration - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    console.log('Days until expiration:', diffDays);
    return diffDays <= 3;
  };

  if (isEmpty(config)) {
    return (
      <Typography variant="h6" sx={{ mt: 2, textAlign: 'center' }}>
        Profile is not defined
      </Typography>
    );
  }

  // Helper for payment warning UI
  const renderPaymentWarning = (type) =>  (
    <>
      <Typography variant='body2' sx={{ color: 'red' }}>
        {type === 'trial'
          ? 'Your trial has ended or is ending soon. Please make a payment to continue using the service.'
          : 'Your subscription has ended or is ending soon. Please, make a payment to continue using the service.'}
      </Typography>
      <ButtonSecurePayment
        onClick={(e) => {
          e.currentTarget.blur();
          if (onStartPayment) {
            onStartPayment();
          }
        }}
      />
    </>
  );


  return (
    <Box
      sx={{
        p: 0,
        width: 300,
        mt: 2,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 400
      }}
    >
      <Divider sx={{ mt: 0, width: '100%', borderColor: 'gray', borderWidth: 1 }} />
      <Typography variant='body2' sx={{ mt: 1 }}>name: {name}</Typography>
      <Typography variant='body2'>email: {email}</Typography>
      <Divider sx={{ mt: 1, width: '100%', borderColor: 'gray', borderWidth: 1 }} />
      {accountStatus.state !== 'tester' && (
        <Typography variant='body2' sx={{ mt: 1 }}>
          Account: {accountStatus.state}
        </Typography>
      )}
      {accountStatus.state === 'trial' && (
        <Typography variant='body2'>
          Trial ends on: {formatDate(accountStatus.trialExpirationDate, false)}
        </Typography>
      )}
      {accountStatus.state === 'paid' && (
        <Typography variant='body2'>
          Next payment due on: {formatDate(accountStatus.nextRenewalDate, false)}
        </Typography>
      )}
      {accountStatus.state === 'tester' && (
        <Typography variant='body2'>Tester account</Typography>
      )}
      {(accountStatus.state === 'trial' && isExpirationNear(accountStatus.trialExpirationDate)) &&
        renderPaymentWarning('trial')
      }
      {(accountStatus.state === 'paid' && isExpirationNear(accountStatus.nextRenewalDate)) &&
        renderPaymentWarning('paid')
      }

      <Divider sx={{ mt: 1, width: '100%', borderColor: 'gray', borderWidth: 1 }} />
      <Typography variant="h6" sx={{ mb: 1, mt: 1 }}>Select the languages</Typography>
      <LangSelection label="Learning" saveLabel={[configKeys.langLearn]} />
      <Box sx={{ mb: 2 }}></Box>
      <LangSelection label="MyLanguage" saveLabel={[configKeys.langBase]} />
      <Divider sx={{ mt: 1, width: '100%', borderColor: 'gray', borderWidth: 1 }} />
      <Button
        variant="outlined"
        startIcon={<LockIcon />}
        onClick={handleChangePasswordClick}
        sx={{ mt: 2 }}
      >
        {!showSubmitNewPassword ? "Change Password" : "Cancel"}
      </Button>
      {showSubmitNewPassword && (
        <SubmitNewPassword email={email} />
      )}
      <Divider sx={{ mt: 2, width: '100%', borderColor: 'gray', borderWidth: 1 }} />
      {/* <Typography variant="h6" sx={{ mt: 2 }}>Leave application</Typography> */}
      <Button
        variant="outlined"
        color="primary"
        onClick={handleLogout}
        startIcon={<LogoutIcon />}
        sx={{
          textTransform: "none",
          fontWeight: "bold",
          borderRadius: "8px",
          padding: "8px 16px",
          mt: 2
        }}
      >
        Logout
      </Button>
      {error && <ErrorDispatcher
                error = {error}
                showDialog = {true}>
                </ErrorDispatcher>}
    </Box>
  );
};

export default Profile;